import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import Hero from './components/Hero';
import Concept from './components/Concept';
import Location from './components/Location';
import Differentials from './components/Differentials';
import FloorPlans from './components/FloorPlans';
import Availability from './components/Availability';
import Gallery from './components/Gallery';
import FAQ from './components/FAQ';
import Contact from './components/Contact';

export default function HomePage() {
  return (
    <div className="min-h-screen">
      <Navbar />
      <main>
        <Hero />
        <Concept />
        <Location />
        <Differentials />
        <FloorPlans />
        <Availability />
        <Gallery />
        <FAQ />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
